/**
 * Create a dom element
 * @param  string elementType Required - The type of element to create
 * @param  object attributes  Optional - A list of attribute to add to the element
 * @param  string textNode    Optional - Any text to add to the element
 * @return object Element
 */
module.exports = (elementType, attributes, textNode) => {
    const element = document.createElement(elementType);

    //
    for (const [attributeName, attributeValue] of Object.entries((attributes || {}))) {
        if (attributeName in element) {
            element[attributeName] = attributeValue
        } else {
            element.setAttribute(attributeName, attributeValue);
        }
    }

    //
    if (typeof textNode !== 'undefined') {
        element.append(document.createTextNode(textNode));
    }

    //
    return element;

};